import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 10rem;
`

export const ColumnBody = styled.div`
  position: relative;
`

export const ColumnList = styled.ul`
  max-height: 19.25rem;
  margin: 0;
  padding: 0 1rem 0 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  list-style: none;
`

export const ColumnFade = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${themeGet('programNav.backgroundColor', 'white')}
  );
`

export const EmptyMessage = styled.p`
  margin: 0;
  padding: 0.25rem 0;
  color: ${themeGet('colors.mediumGray')};
  font-family: ${themeGet('fontFamily')};
  font-size: 0.875rem;
  font-style: italic;
`
